"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _react = _interopRequireDefault(require("react"));
var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));
var _idbReactQr = _interopRequireDefault(require("@identitybuilding/idb-react-qr"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ContactCard = function ContactCard(_ref) {
  var color = _ref.color,
    entity = _ref.entity,
    lang = _ref.lang;
  var translate = function translate(e) {
    return (0, _idbReactTranslations["default"])(e, lang);
  };

  // Push all the contact information of the enterprise inside an array
  var contact_data = [];
  if (entity.telephone) contact_data.push({
    data: entity.telephone,
    icon: "Phone"
  });
  if (entity.cellphone) contact_data.push({
    data: entity.cellphone,
    icon: "Cellphone"
  });
  if (entity.fax) contact_data.push({
    data: entity.fax,
    icon: "Fax"
  });
  contact_data.push({
    data: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, entity.enterprise_name, " ", entity.enterprise_name && entity.juridical_form, /*#__PURE__*/_react["default"].createElement("br", null), translate("entrepreneurs_number") + ": ", entity.vat_number, /*#__PURE__*/_react["default"].createElement("br", null), entity.establishment_number && translate("establishment_number") + ": " + entity.establishment_number, /*#__PURE__*/_react["default"].createElement("br", null), entity.address.rpr_court && entity.address.rpr_division && /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactAddress"
    }, (0, _idbReactTranslations["default"])("rpr", entity.address.rpr_lang), " ", entity.address.rpr_court, ", ", (0, _idbReactTranslations["default"])("division", entity.address.rpr_lang), " ", entity.address.rpr_division), entity.registration_numbers.map(function (item, index) {
      return item.type === "Registration" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: index
      }, translate(item.type.toLowerCase()) + ": " + item.number, /*#__PURE__*/_react["default"].createElement("br", null)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: index
      }, translate(item.type.toLowerCase()).toUpperCase() + ": " + item.number, /*#__PURE__*/_react["default"].createElement("br", null));
    })),
    icon: "Entrepreneur"
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "contactCard",
    className: color ? color : "main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactInfoBlock",
    style: {
      justifyContent: contact_data.length > 1 && "space-between"
    }
  }, entity.address && /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactRow"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactIcon"
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Mapmarker"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactInfo"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    title: entity.address.line_1,
    className: "contactAddress"
  }, entity.address.line_1), entity.address.extra_info && /*#__PURE__*/_react["default"].createElement("span", {
    title: entity.address.line_1,
    className: "contactAddress"
  }, "(", entity.address.extra_info, ")"), /*#__PURE__*/_react["default"].createElement("span", {
    title: entity.address.line_2,
    className: "contactLocation"
  }, entity.address.line_2))), contact_data.map(function (item, index) {
    return (item.icon === 'Cellphone' || item.icon === 'Phone') && item.data.length > 0 ? item.data.map(function (res, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "contactRow",
        key: i
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "contactIcon"
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: item.icon
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "contactInfo"
      }, res));
    }) : item.icon !== "Cellphone" && item.icon !== "Phone" ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "contactRow",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "contactIcon"
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: item.icon
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "contactInfo"
    }, item.data)) : "";
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactQR"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, translate("add_as_mobile_contact")), /*#__PURE__*/_react["default"].createElement(_idbReactQr["default"], {
    cell: entity.cellphone[0],
    color: "#000",
    name: entity.establishment_name,
    tel: entity.telephone[0],
    url: entity.website
  })));
};
var _default = exports["default"] = ContactCard;